import {
  Button as MantineButton,
  type ButtonProps as MantineButtonProps,
} from "@mantine/core";
import type { ReactNode } from "react";
import clsx from "clsx";
import styles from "../Button.module.scss";

type IconButtonVariant =
  | "primary"
  | "secondary"
  | "tertiary"
  | "neutral-primary"
  | "neutral-secondary"
  | "destructive-primary"
  | "destructive-secondary";

export type IconButtonProps = {
  children?: ReactNode;
  isDisabled?: boolean;
  variant: IconButtonVariant;
  size?: "small" | "base" | "large";
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
} & Omit<MantineButtonProps, "variant" | "size">;

export function IconButton(props: IconButtonProps) {
  const { variant, size = "base", isDisabled, children, ...rest } = props;

  const variantClassName = styles[`button-${variant}`] || "";
  const sizeClassName = styles[`button-size-${size}`];
  const typeClassName = styles["icon-shape"];

  const finalClassName = isDisabled
    ? clsx(
        styles["button-disabled"],
        styles["base-button"],
        sizeClassName,
        typeClassName
      )
    : clsx(
        variantClassName,
        styles["base-button"],
        sizeClassName,
        typeClassName
      );

  const isOutlineVariant =
    variant === "secondary" ||
    variant === "tertiary" ||
    variant === "neutral-secondary" ||
    variant === "destructive-secondary";

  return (
    <MantineButton
      className={finalClassName}
      variant={isOutlineVariant ? "outline" : "filled"}
      disabled={isDisabled}
      {...rest}
    >
      {children}
    </MantineButton>
  );
}
